import Vuex from "vuex";

const store = new Vuex.Store({
  state: {
    shoe_id: 0,
    parts: [],
    /**
     * content: "123"
       direction: "side"
       font_color: "rgb(253,227,0)"
       font_type: "text_Arial"
       img_name: ""
       img_src: ""
       mounted_logo_id: 0
       part_id: "a"
     */
    embroidery: [],
    no_wheel: false,
    name: "",
    tel: "",
    mail: "",
    postcode: "",
    personal_address: "",
    mx_shop: "",
    mx_address: "",
    requirement_text: "",
    requirement_img_base64:[],
    requirement_img_name:[]
  },
  mutations: {
    requirementImgBase64Change: function (state, requirement_img_base64) {
      state.requirement_img_base64 = requirement_img_base64;
    },
    requirementImgNameChange: function (state, requirement_img_name) {
      state.requirement_img_name = requirement_img_name;
    },
    requirementTextChange: function (state, requirement_text) {
      state.requirement_text = requirement_text;
    },
    nameChange: function (state, name) {
      state.name = name;
    },
    telChange: function (state, tel) {
      state.tel = tel;
    },
    mailChange: function (state, mail) {
      state.mail = mail;
    },
    postcodeChange: function (state, postcode) {
      state.postcode = postcode;
    },
    personalAddressChange: function (state, personal_address) {
      state.personal_address = personal_address;
    },
    mxShopChange: function (state, mx_shop) {
      state.mx_shop = mx_shop;
    },
    mxAddressChange: function (state, mx_address) {
      state.mx_address = mx_address;
    },
    shoeIdChange: function (state, shoeId) {
      state.shoe_id = shoeId;
    },
    changeWheelStatus: function (state, status) {
      state.no_wheel = status;
    },
    changeParts(state, parts) {
      state.parts = parts;
    },
    changeEmbroidery(state, embroidery) {
      state.embroidery = embroidery;
    },
    changeSpecificPart(state, part) {
      let temp = state.parts.map((item) => {
        if (item.part_id == part.part_id) {
          // console.log("123-item.part_id == part.part_id",part.part_id);
          return part;
        } else {
          // console.log("123-item.part_id != part.part_id",item.part_id);
          return item;
        }
      });
      // console.log("123-temp",temp);
      state.parts = temp;
    },

    initState(state) {
      state.shoe_id = 0
      state.parts = []
      state.embroidery = []
      state.no_wheel = false
      state.name = ""
      state.tel = ""
      state.mail=""
      state.postcode = ""
      state.personal_address = ""
      state.mx_shop = ""
      state.mx_address = ""
      state.requirement_text = ""
      state.requirement_img_base64 = []
      state.requirement_img_name = []
    }
  },
});

export default store;
